// extracted by mini-css-extract-plugin
export var container = "_2j-1";
export var editor = "_2j-2";
export var resizable = "_2j-3";
export var wrapper = "_2j-0";